module.exports = __webpack_public_path__ + "static/media/close.bff76689.svg";